import { CHANGE_CURRENT_LOCALE } from './constants';

import fr from './json/fr';
import it from './json/it';
import es from './json/es';

import igraal from './json/117';
import bfm from './json/127';
import bnp4 from './json/131.json';
import bnp6 from './json/132.json';
import bnp8 from './json/133.json';
import bnp10 from './json/134.json';
import myworld from './json/198.json';
import mareduc from './json/204.json';

const initialState = {
    fr,
    it,
    es
};
const overridedState = {
    117: igraal,
    127: bfm,
    131: bnp4,
    132: bnp6,
    133: bnp8,
    134: bnp10,
    198: myworld,
    204: mareduc
};

export default function reducer(state = initialState.fr, action) {
    switch (action.type) {
        case CHANGE_CURRENT_LOCALE:
            return { ...initialState[action.newState], ...overridedState };
        default:
            return { ...state, ...overridedState };
    }
}



// WEBPACK FOOTER //
// ./src/services/i18n/reducer.js